import { css } from '@emotion/core';

export const containerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 32px 0;
`;
